var exports = {
  "i": "x93eb46d8--218bc5--wrapper",
  "D": "x93eb46d8--218bc5--carousel",
};

module.exports = exports;
